import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';


function ProjectAccounting() {
  return (
    <>
<Features docname="Project Accounting and Financial Analysis"/>
<Advantages docname="Project Accounting and Financial Analysis"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default ProjectAccounting;
